var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"title":_vm.$t('bans.pageTitle'),"description":_vm.$t('bans.pageSubtitle'),"to":{ name: _vm.RouteName.Moderation }}},[_c('BanManager')],1)}
var staticRenderFns = []

export { render, staticRenderFns }